import React, {useCallback, useEffect, useState} from "react";
import {Modal} from "react-bootstrap";

// Some style workarounds had to be done to fit react-bootstrap modal styling to the uibModal css classes.
// - backdropClassName needs 'in' class because uibModal uses 'in' instead of 'show' like bootstrap
// - Modal className needs 'in' and 'out'
export const VersionModal = ({open, toggle, frontendVersion}) => {
  const [versions, setVersions] = useState({});

  const loadVersions = useCallback(async () => {
    if (open) {
      const response = await fetch("/actuator/info");
      const info = await response.json();
      if (info) {
        setVersions(info.versions);
      }
    }
  }, [open, setVersions]);
  useEffect(() => {
    loadVersions();
  }, [loadVersions]);

  return (
    <Modal id="versionModal" aria-labelledby="versionModalLabel" backdropClassName={"modal-backdrop in"} show={open}
           onHide={toggle} className={open ? "modal-open in" : "modal-closed out"}>
      <Modal.Header>
        <Modal.Title id="versionModalLabel">
          Smartvision Service Versions
        </Modal.Title>
        <button aria-label="Close" className="close" type="button" onClick={toggle}/>
      </Modal.Header>
      <div className={"simple-table"}>
        <table>
          <thead>
          <tr>
            <th>Service</th>
            <th>Version</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>frontend</td>
            <td>{frontendVersion}</td>
          </tr>
          {Object.entries(versions).map(version => <tr key={version[0]}>
            <td>{version[0]}</td>
            <td>{version[1]}</td>
          </tr>)}
          </tbody>
        </table>
      </div>
      <Modal.Footer>
        <button className="toolbar-button" onClick={toggle}>OK</button>
      </Modal.Footer>
    </Modal>
  )
}